import React from "react";
import { Progress } from "reactstrap";

const UnsortableItem = props => {
  let { removeItem, value, sortIndex } = props;

  let style = value.url
    ? {
        backgroundImage: "url(" + value.url + ")"
      }
    : {
        backgroundImage: "url(" + value.preview + ")"
      };

  return (
    <div
      className={
        "dropzone-item " + (value.progress === 100 ? "complete" : "incomplete")
      }
    >
      <div className={`image-preview ${this.previewClass}`} style={style} />
      <div className="progress">
        <Progress value={value.progress} />
      </div>
      <div className="actions ml-auto">
        <i className="fas fa-times" onClick={() => removeItem(sortIndex)} />
      </div>
    </div>
  );
};

export default UnsortableItem;



// WEBPACK FOOTER //
// ./src/system/fields/FileUpload/UnsortableItem.jsx